"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    teachingPopoverCarouselFooterClassNames: function() {
        return teachingPopoverCarouselFooterClassNames;
    },
    useTeachingPopoverCarouselFooterStyles_unstable: function() {
        return useTeachingPopoverCarouselFooterStyles_unstable;
    }
});
const _react = require("@griffel/react");
const teachingPopoverCarouselFooterClassNames = {
    root: 'fui-TeachingPopoverCarouselFooter',
    previous: 'fui-TeachingPopoverCarouselFooter__previous',
    next: 'fui-TeachingPopoverCarouselFooter__next'
};
// Todo: Page change animation & styles
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1063pyq"
    },
    rootCentered: {
        Brf1p80: "f1869bpl",
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "f19gb1f4"
    },
    rootRightAligned: {
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "f19gb1f4",
        Bp34fd5: "f1y65ohq"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1063pyq{flex-direction:row;}",
        ".f1869bpl{justify-content:space-between;}",
        [
            ".f19gb1f4{gap:8px;}",
            {
                p: -1
            }
        ],
        [
            ".f19gb1f4{gap:8px;}",
            {
                p: -1
            }
        ],
        ".f1y65ohq :first-child{-webkit-margin-end:auto;margin-inline-end:auto;}"
    ]
});
const useTeachingPopoverCarouselFooterStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    const { layout } = state;
    state.root.className = (0, _react.mergeClasses)(teachingPopoverCarouselFooterClassNames.root, styles.root, layout === 'centered' ? styles.rootCentered : styles.rootRightAligned, state.root.className);
    if (state.previous) {
        state.previous.className = (0, _react.mergeClasses)(teachingPopoverCarouselFooterClassNames.previous, state.previous.className);
    }
    state.next.className = (0, _react.mergeClasses)(teachingPopoverCarouselFooterClassNames.next, state.next.className);
    return state;
}; //# sourceMappingURL=useTeachingPopoverCarouselFooterStyles.styles.js.map
